<template>
  <div>
    <b-modal hide-footer ref="modalOptionData" id="modalOptionData" :title="$t('DHCPv6 опция')">
      <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="selectOptionData.name" aria-describedby="inputFeedbackNameOptionData" :state="selectOptionData.name.length > 0"/>
        <b-form-invalid-feedback id="inputFeedbackNameOptionData"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="selectOptionData.code"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Space')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group>
          <b-form-input type="text" v-model="selectOptionData.space"/>
          <b-input-group-append>
            <span id="tooltip">
              <b-img :src="questionImage"/>
            </span>
            <b-tooltip target="tooltip" triggers="hover">
              ( dhcp6 | vendor-opts-space ) or custom in case of Nested DHCPv6 Options
            </b-tooltip>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Data')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="selectOptionData.data" aria-describedby="inputFeedbackData" :state="selectOptionData.data.length > 0"/>
        <b-form-invalid-feedback id="inputFeedbackData"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Csv-format')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-checkbox v-model="selectOptionData['csv-format']"/>
      </b-form-group>

      <modal-ok-cancel @save="saveOptionData" @cancel="$bvModal.hide('modalOptionData')" />

    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null,
    selectOptionData: null,
    selectSubnet: null
  },
  data () {
    return {
      numOptionData: 1000000,
      questionImage: require('@/assets/img/question.png')
    }
  },
  methods: {
    saveOptionData () {
      if (!this.selectOptionData.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (!this.selectOptionData.data) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Data'), 'Error')
        return
      }

      if (this.selectOptionData.isEdit) {
        if (this.selectSubnet.isSubnet) {
          for (let el of this.selectSubnet['option-data']) {
            if (el.numOptionData === this.selectOptionData.numOptionData) {
              el.name = this.selectOptionData.name
              el.code = Number(this.selectOptionData.code)
              el.data = this.selectOptionData.data
              el['csv-format'] = this.selectOptionData['csv-format']
            }
          }
        } else {
          for (let el of this.editItem['option-data']) {
            if (el.numOptionData === this.selectOptionData.numOptionData) {
              el.name = this.selectOptionData.name
              el.code = Number(this.selectOptionData.code)
              el.data = this.selectOptionData.data
              el['csv-format'] = this.selectOptionData['csv-format']
            }
          }
        }
      } else {
        this.selectOptionData.numOptionData = ++this.numOptionData
        this.selectOptionData.code = Number(this.selectOptionData.code)
        if (this.selectSubnet.isSubnet) {
          this.selectSubnet['option-data'].push(this.selectOptionData)
        } else {
          this.editItem['option-data'].push(this.selectOptionData)
        }
      }
      this.$refs.modalOptionData.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/DHCPv6/modalOptionData.vue